import { render, staticRenderFns } from "./OpenOnlineService.vue?vue&type=template&id=2179b99c&"
import script from "./OpenOnlineService.vue?vue&type=script&lang=js&"
export * from "./OpenOnlineService.vue?vue&type=script&lang=js&"
import style0 from "./OpenOnlineService.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports